/* eslint-disable */
//import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import App from '../react/ReverseMortgageCalculator';

class ReverseMortgageCalculator {
    constructor() {
        this.container = document.querySelector('#ReverseMortgageCalculator');

        if (this.container) {
            ReactDOM.render(<App />, document.getElementById('ReverseMortgageCalculator'));
        }
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {

    }
}

export default ReverseMortgageCalculator;